import React from 'react';
import { Gift, Star, ArrowRight } from 'lucide-react';
import { Button } from '@/components/Button';

interface BannerSlideProps {
    isLoggedIn: boolean;
}

export const RewardsStoreBannerSlide: React.FC<BannerSlideProps> = ({ isLoggedIn }) => {
    return (
        <div className="w-full shrink-0 flex flex-col md:flex-row items-center gap-6 px-4">
            <div className="flex relative z-10 shrink-0 group-hover:scale-105 transition-transform duration-500">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-pink-500 to-rose-600 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-2xl relative">
                    <Gift className="w-10 h-10 md:w-14 md:h-14 text-white drop-shadow-md" />
                    <div className="absolute -top-1 -right-1 w-8 h-8 md:w-10 md:h-10 bg-yellow-400 rounded-full flex items-center justify-center shadow-md animate-bounce">
                        <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-900 fill-current" />
                    </div>
                </div>
            </div>
            <div className="flex-1 text-center md:text-left z-10 mt-4 md:mt-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-pink-500/10 to-rose-500/10 border border-pink-500/20 rounded-full text-pink-600 dark:text-pink-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-3">
                    <Gift className="w-3.5 h-3.5 fill-current" />
                    Lojinha de Resgate
                </div>
                <h3 className="text-xl md:text-2xl font-black text-gray-900 dark:text-white mb-2 leading-tight">
                    Troque seus pontos!
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-5 text-balance">
                    Use os pontos que você juntou no Radar para pegar recompensas incríveis. Acesse a Lojinha e escolha a melhor recompensa para você!
                </p>
                <div className="flex items-center justify-center md:justify-start">
                    <Button
                        variant="primary"
                        className="bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-700 hover:to-rose-700 shadow-lg shadow-rose-500/25 border-0 text-sm px-6 py-2.5 whitespace-nowrap"
                    >
                        {isLoggedIn ? 'Acessar a Lojinha' : 'Acessar a Lojinha'}
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
